import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AuthForm from './components/AuthForm/index';
import ForgotPass from './components/ForgotPass/index';

function AuthPage() {
  const [forgot, setForgot] = useState(false);
  return (
    <div className="flex items-center h-full justify-center">
      {!forgot && <AuthForm setForgot={setForgot} />}
      {forgot && <ForgotPass setForgot={setForgot}/>}
    </div>
  );
}

AuthPage.propTypes = {};

export default AuthPage;
